jQuery(document).ready(function($){
  
  $('a[data-lang]').click(function(event) {
        event.preventDefault();  // Prevent the default action

        var langCode = $(this).data('a');
        var newLang = (langCode === '1' ? 'en' : 'th');  // Map '1' to 'en' and '2' to 'th'
        var currentPath = window.location.pathname;

        // Remove any existing language code
        var newPath = currentPath.replace(/^\/(en|th)(\/|$)/, '/');

        // Insert the new language code
        newPath = '/' + newLang + newPath;

        // Redirect to the new URL
        window.location.pathname = newPath;
    });
  $('.sidebar-tag a:not(".clear"), .sidebar-tag label').click(function(e) {
  		var size = $(this).text();
    	console.log(size);
  });
  
  var mobileHover = function () {
    $('*').on('touchstart', function () {
      $(this).trigger('hover');
    }).on('touchend', function () {
      $(this).trigger('hover');
    });
  };
  mobileHover();
  if($(window).width() > 767) {
    $('.site-nav:not(.custom-nav) > li:last-child > ul > li:last-child').click(function(event){
      event.preventDefault();
      $('#instagram').modal();
    });
    $('.site-nav > li:nth-child(4) > a, a.blogmore').click(function(event){
      event.preventDefault();
      $('#blogchoice').modal();
    });
  }
  $('a.various').attr('rel','gallery').fancybox();
  $('.storepics').flexslider({
    animation: "slide",
    directionNav: false,
  });

  $('#lang-switcher').change(function(){
    $('body').removeClass('lang1');
    $('body').removeClass('lang2');
    $('body').addClass('lang' + $(this).val());
  });

  $('.product-description h3').click(function(){
    $('.product-description-panel').slideToggle(400);
  });

  $('.product-list .col-md-3').matchHeight();

  $(window).load(function() {
    if($('#cartToggle span.first').text() == "Shopping Cart") {
      if($('#customcheckout').length > 0) {
        $('#customcheckout').attr('action','/cart?locale=en');
      }
      $('#dropdown-cart .actions form').attr('action','/cart?locale=en');
    }
    else {
      if($('#customcheckout').length > 0) {
        $('#customcheckout').attr('action','/cart?locale=th');
      }
      $('#dropdown-cart .actions form').attr('action','/cart?locale=th');
    }
  });
  /*$('.mobile-menu .wrapper').mCustomScrollbar();*/

  $('.mobile-menu .wrapper li').on('click', function(event){ 
    event.stopPropagation();
    if($(this).children('ul').length > 0) {
      if($(this).hasClass('open')) {
        $(this).removeClass('open').children('ul').slideUp();
      }
      else {
        $(this).parent().find('li.open').removeClass('open').children('ul').slideUp();
        $(this).addClass('open').children('ul').slideDown();
      }
    }
  });

  $(window).scroll(function(){
    if($(this).scrollTop() > 150) {
      if(!$('.site-header').hasClass('sticky')) {
        $('.site-header').addClass('sticky');
      }
    }
    else {
      $('.site-header').removeClass('sticky');
    }
  });
  $('#homepage-product-slider').addClass('owl-carousel').owlCarousel({
    responsive:{
      0:{ items: 1 },
      480:{ items: 3 },
      767:{ items: 5 },
    },
    loop: true,
    dots: true,
    nav: false,
  });
  
});
